const selectLanguages = (state) => state.settings.languages.self.languages
const selectLoader = (state) => state.settings.languages.self.loader
const selectError = (state) => state.settings.languages.self.error

const selectTagsAndSegments = (state) => state.settings.languages.self.tagsAndSegments
const selectSelectedTagsOrSegments = (state) => state.settings.languages.self.selectedTagsOrSegments

const selectSaveLanguageFromTags = (state) => state.settings.languages.self.saveLanguageFromTags

export {
  selectLanguages,
  selectLoader,
  selectError,
  selectTagsAndSegments,
  selectSelectedTagsOrSegments,
  selectSaveLanguageFromTags,
}
